"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const beerCategories = [{
  title: "Autonoma Resor",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/stockholm_tesla_dawn.png",
  link: "/BecomeOperatorPage"
}, {
  title: "Insikter & Data",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/robotaxi_tech.png",
  link: "/InsightsPage"
}, {
  title: "Trygg Försäkring",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/safety_sensors.png",
  link: "/CheaperInsurancePage"
}, {
  title: "Bli Operatör",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/smart_city_flow.png",
  link: "/BecomeOperatorPage"
}];
export default function DiscoverItalianBrewingArt() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="108524" id="hero" className="bg-background py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif font-bold text-4xl md:text-5xl lg:text-6xl text-primary mb-6 tracking-tight leading-tight">
            Framtidens mobilitet är här
          </h1>
          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
            Upplev den autonoma revolutionen i hjärtat av Stockholm. Vi bygger morgondagens transportlösningar med fokus på säkerhet, hållbarhet och effektivitet för alla medborgare.
          </p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {beerCategories.map((category, i) => <div key={category.title} data-index={i} className="group relative overflow-hidden aspect-[4/3] md:aspect-[3/2] bg-muted shadow-sm">
              {}
              <img src={category.image} alt={category.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" />

              {}
              <div className="absolute inset-0 bg-primary/30 backdrop-blur-[2px] transition-colors duration-500 group-hover:bg-primary/50" />

              {}
              <div className="absolute inset-0 flex items-center justify-center p-6 pointer-events-none">
                <h2 className="font-serif font-bold text-3xl md:text-4xl lg:text-5xl text-white text-center drop-shadow-lg">
                  {category.title}
                </h2>
              </div>

              {}
              <div className="absolute bottom-8 left-0 right-0 flex justify-center">
                <Button asChild variant="default" size="lg" className="rounded-[3px] font-sans font-medium tracking-widest uppercase shadow-md transition-transform duration-300 hover:-translate-y-1 bg-primary text-primary-foreground">
                  <Link to={category.link}>SIGN UP</Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}